import React, { useRef, useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate, useLocation } from "react-router-dom";
import "./NewGrievance.css";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ApiUrl } from "../../../ApiUrl";

const AdmAttendanceEntry = () => {
  const navigate = useNavigate();
 
  // const placementData = location.state?.placementData || {}; // Retrieve passed data
   const [typeOptions, setTypeOptions] = useState([]);
   const [severityOptions, setSeverityOptions] = useState([]);
   const [priorityOptions, setPriorityOptions] = useState([]);

   const [selectedType, setSelectedType] = useState(null);
   const [selectedSeverity, setSelectedSeverity] = useState(null);
   const [selectedPriority, setSelectedPriority] = useState(null);
   const [grievanceDetails, setGrievanceDetails] = useState("");
   const [isAnonymous, setIsAnonymous] = useState(false);
   const [uploadFile, setUploadFile] = useState(null);
   const [formError, setFormError] = useState("");

 
   
const fileInputRef = useRef(null);

   useEffect(() => {
     const fetchOptions = async (url, setOptions, valueKey, labelKey) => {
       try {
         const response = await fetch(url);
         const data = await response.json();
         if (data && data.data) {
           setOptions(
             data.data.map((item) => ({
               value: item[valueKey],
               label: item[labelKey],
             }))
           );
         }
       } catch (error) {
         console.error(`Error fetching ${labelKey} options:`, error);
       }
     };

     fetchOptions(
       `${ApiUrl.apiurl}GrievanceType/list/`,
       setTypeOptions,
       "Giv_id",
       "GrievanceType"
     );
     fetchOptions(
       `${ApiUrl.apiurl}GrievanceSeverity/list/`,
       setSeverityOptions,
       "Sev_id",
       "SeverityType"
     );
     fetchOptions(
       `${ApiUrl.apiurl}GrievancePriority/list/`,
       setPriorityOptions,
       "GP_id",
       "PriorityType"
     );
   }, []);

  const handleSave = async () => {
    const userId = sessionStorage.getItem("userId") || "";
    const orgId = localStorage.getItem("orgId") || "";
    const branchId = localStorage.getItem("branchId") || "";

    if (!selectedType || !selectedSeverity || !selectedPriority || !grievanceDetails.trim()) {
      setFormError("Please select Type, Severity, Priority, and enter Grievance Details.");
      return;
    }

    setFormError("");

    const formData = new FormData();
    formData.append("GrievanceType", selectedType?.value || "");
    formData.append("GrievancePriority", selectedPriority?.value || "");
    formData.append("GrievanceSeverity", selectedSeverity?.value || "");
    formData.append("details", grievanceDetails);
    formData.append("Anonymous", isAnonymous ? true : false);
    if (uploadFile instanceof File) {
      formData.append("upload_file", uploadFile);
    }
    formData.append("created_by", userId);
    formData.append("org_id", orgId);
    formData.append("branch_id", branchId);

    try {
      const response = await fetch(`${ApiUrl.apiurl}Grievance/create/`, {
        method: "POST",
        body: formData,
      });
      const result = await response.json();
      console.log("API Response:", result);
      alert("Grievance submitted successfully!");
    } catch (error) {
      console.error("Error submitting grievance:", error);
      alert("Submission failed!");
    }
  };


  const handleClear = () => {
    setSelectedType(null);
    setSelectedSeverity(null);
    setSelectedPriority(null);
    setGrievanceDetails("");
    setIsAnonymous(false);
    setUploadFile(null);
    setFormError("");

    // Reset file input field
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card p-2">
            <div className="card-body">
              <p
                className="text-center fw-bold mb-3"
                style={{ fontSize: "18px" }}
              >
                STUDENT GRIEVANCES
              </p>
              <div className="row mb-3 mt-3  mx-0">
                <div div className="col-12 d-flex flex-wrap gap-2">
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleSave}
                  >
                    Save
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleClear}
                  >
                    Clear
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={() => navigate("/student/grievance")}
                  >
                    Close
                  </button>
                </div>
              </div>

              <div className="row mt-3 mx-2">
                <div className="col-12 form-container custom-section-box">
                  {formError ? (
                    <div className="alert alert-danger mt-3 mb-0">{formError}</div>
                  ) : null}
                  <div className="form-grid mt-4 mx-2  mb-4">
                    {/* Left Column - Labels */}
                    <div className="form-labels">
                      <label>Type </label>
                      <label>Severity </label>
                      <label>Priority </label>
                      <label>Grievance Details</label>
                      <label>Upload </label>
                      <label></label> {/* Empty label for alignment */}
                    </div>

                    {/* Right Column - Input Fields */}
                    <div className="form-inputs">
                      <Select
                        options={typeOptions}
                        classNamePrefix="custom-select"
                        value={selectedType}
                        onChange={setSelectedType}
                      />
                      <Select
                        options={severityOptions}
                        classNamePrefix="custom-select"
                        value={selectedSeverity}
                        onChange={setSelectedSeverity}
                      />
                      <Select
                        options={priorityOptions}
                        classNamePrefix="custom-select"
                        value={selectedPriority}
                        onChange={setSelectedPriority}
                      />

                      <input
                        type="text"
                        name="grievanceDetails"
                        className="input-field"
                        style={{ textAlign: "left" }} // Ensuring text starts from the left
                        value={grievanceDetails}
                        onChange={(e) => setGrievanceDetails(e.target.value)}
                      />

                      <input
                        type="file"
                        name="upload"
                        className="input-field"
                        ref={fileInputRef}
                        onChange={(e) => setUploadFile(e.target.files[0])}
                      />

                      {/* Checkbox for Anonymous Submission */}
                      <div className="checkbox-container">
                        <input
                          type="checkbox"
                          id="anonymousCheckbox"
                          checked={isAnonymous}
                          onChange={(e) => setIsAnonymous(e.target.checked)}
                        />
                        <label htmlFor="anonymousCheckbox">
                          Submit as Anonymous User
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AdmAttendanceEntry;



